import LoadingPanel from '../../../Abstracts/Components/LoadingPanel';
import useEftposBookings from '../../../Hooks/UseEftposBookings';
import EftposBookingsTable from './EftposBookingsTable';
import useEftposDepositAccounts from '../../../Hooks/UseEftposDepositAccounts';
import useEftposPosLists from '../../../Hooks/UseEftposPosLists';
import { BackButton } from '../BreadCrumbs';

export default function BookingList() {
	const { eftposBookings, setEftposBookings } = useEftposBookings();
	const eftposDepositAccounts = useEftposDepositAccounts();
	const eftposPosLists = useEftposPosLists();

	if (!eftposBookings || !eftposDepositAccounts || !eftposPosLists) {
		return <LoadingPanel />;
	}

	const todayAtMidnight = new Date();
	todayAtMidnight.setHours(0, 0, 0, 0);
	const pastBookings = eftposBookings.filter((booking) => booking.MarketDate * 1000 < todayAtMidnight.getTime());

	const tomorrowAtMidnight = new Date();
	tomorrowAtMidnight.setDate(tomorrowAtMidnight.getDate() + 1);
	tomorrowAtMidnight.setHours(0, 0, 0, 0);
	const upcomingBookings = eftposBookings.filter(
		(booking) => booking.MarketDate * 1000 > tomorrowAtMidnight.getTime(),
	);

	const bookingsToday = eftposBookings.filter((booking) => {
		const bookingDate = new Date(booking.MarketDate * 1000);
		return (
			todayAtMidnight.getTime() <= bookingDate.getTime() && bookingDate.getTime() < tomorrowAtMidnight.getTime()
		);
	});

	return (
		<>
			<BackButton text="Back" to="/" />
			{bookingsToday.length !== 0 && (
				<>
					<h4>Today</h4>
					<EftposBookingsTable
						bookings={bookingsToday}
						setBookings={setEftposBookings}
						posLists={eftposPosLists}
						depositAccounts={eftposDepositAccounts}
						context="bookings"
					/>
				</>
			)}
			{upcomingBookings.length !== 0 && (
				<>
					<h4>Upcoming bookings</h4>
					<EftposBookingsTable
						bookings={upcomingBookings}
						setBookings={setEftposBookings}
						posLists={eftposPosLists}
						depositAccounts={eftposDepositAccounts}
						context="bookings"
					/>
				</>
			)}
			{pastBookings.length !== 0 && (
				<>
					<h4>Past bookings</h4>
					<EftposBookingsTable
						bookings={pastBookings}
						setBookings={setEftposBookings}
						posLists={eftposPosLists}
						depositAccounts={eftposDepositAccounts}
						context="bookings"
					/>
				</>
			)}
		</>
	);
}
